export const checkExpired = function checkExpired(timeStamp) {
  return new Date().getTime() > timeStamp;
};
export const getLocalStorage = function getLocalStorage(key) {
  let value;
  if (key && typeof localStorage === 'object') {
    try {
      value = JSON.parse(localStorage.getItem(key));
      if (value && value.timeStamp) {
        value.isExpired = checkExpired(value.timeStamp);
        if (value.isExpired) {
          localStorage.removeItem(key);
        }
      }
    } catch (err) {
      console.warn(err);
    }
  }
  return value;
};
export const setLocalStorage = function setLocalStorage(key, value) {
  if (typeof localStorage === 'object') {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch (err) {
      console.warn(err);
      return false;
    }
  }
  return undefined;
};

export const removeExpiryObjectFromLocalStorage = function removeExpiryObjectFromLocalStorage(
  key,
) {
  if (typeof localStorage === 'object') {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (err) {
      console.warn(err);
      return false;
    }
  }
  return undefined;
};
